<template>
  <v-dialog v-model="value" fullscreen>
    <v-card class="green lighten-5">
      <v-card-title>
        <span>{{generatedLink}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('input',false)" icon color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="5">
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="fwidth" type="number" :label="$t('admin.fwidth')"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fheight" type="number" :label="$t('admin.fheight')"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="cardlen"
                  type="number"
                  class="mr-4"
                  :label="$t('admin.fcardlen')"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="deflang" :label="$t('admin.deflang')"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="5">
            <iframe
              :src="generatedLink"
              allowtransparency="true"
              :width="fwidth"
              :height="fheight"
              frameborder="0"
              scrolling="no"
              class="elevation-2 yellow lighten-5"
              style="overflow:hidden;"
            ></iframe>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="subheader-2">{{insertFrame}}</v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const API =
  process.env.NODE_ENV === "production"
    ? "https://api.e-kartes.lv/info/?"
    : "http://192.168.112.114:8081/?";

export default {
  name: "FrameSetting",
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean }
  },
  computed: {
    generatedLink() {
      try {
        let link = API; //"https://api.e-kartes.lv/info/index.html?";
        //let link = "http://192.168.112.114:8081?";
        if (this.item.hashid) link += "f=" + this.item.hashid;
        if (this.cardlen) link += "&cl=" + this.cardlen;
        if (this.deflang) link += "&l=" + this.deflang;
        return link;
      } catch (e) {
        console.log(this.item, e)
        return "";
      }
    },
    insertFrame() {
      return (
        '<iframe src="' +
        this.generatedLink +
        '" allowtransparency="true" width="' +
        this.fwidth +
        '" height="' +
        this.fheight +
        '" frameborder="0" scrolling="no" style="overflow:hidden;"></iframe>'
      );
    }
  },
  data() {
    return {
      fwidth: 400,
      fheight: 350,
      cardlen: 0,
      deflang: "lv",
      item: { ...this.record }
    };
  },
  watch: {
    record: {
      handler(v) {
        this.item = { ...v };
      },
      deep: true
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>

<style>
</style>